import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from "@angular/core";

@Component({
  selector: "app-icon-button",
  templateUrl: "./icon-button.component.html",
  styleUrl: "./icon-button.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconButtonComponent {
  public readonly icon: InputSignal<string | undefined> = input<string | undefined>();
  // Stays optional: only some call sites bind ariaLabel.
  public readonly ariaLabel: InputSignal<string | undefined> = input<string | undefined>();
  public readonly loading: InputSignal<boolean | undefined> = input<boolean | undefined>();

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  public readonly onClick: OutputEmitterRef<void> = output<void>();

  public handleOnClick(): void {
    this.onClick.emit();
  }
}
